module.exports = __webpack_public_path__ + "img/532.08444b1d.png";